// eslint-disable-next-line no-restricted-imports
import * as yup from 'yup';

export {yup};
export type YupSchema =
  | yup.ObjectSchema<any, any>
  | yup.StringSchema
  | yup.NumberSchema
  | yup.ArraySchema<any, any>
  | yup.BooleanSchema
  | yup.DateSchema;
